<template>
<div class="five wide column sticky sidebar">
  <div id="sidebar" v-bind:class="{ 'closed': !isOpen }">
    <button class="handle" v-on:click="toggleSidebar()"></button>
    <div class="ui grid sidebar-quote">
      <div class="ten wide column sidebar-header">
        <h2 class="sidebar-quote-title">
          <i class="blue file outline icon"></i>
          <span class="sidebar-quote-title-label">{{ quoteType }} Quote</span>
          <span class="sidebar-quote-title-number" v-if="quote.number" v-text="quote.number"></span>
        </h2>
      </div>
      <div class="six wide column sidebar-quote-number-col" v-if="quote.number">
        <div class="sidebar-quote-number" v-text="quote.number"></div>
      </div>
      <div class="six wide column sidebar-quote-header-right">
        <div class="mobile-only-quote-total-header">
          <span class="quote-total-heading">TOTAL:</span>
          <span class="quote-total-value-group">
            <span class="quote-total-amount">{{ currency(quote.total, '$', 2, { decimalSeperator: ','}) }}</span>
            <button
              type="button"
              class="quote-pricing-details-btn mobile-only-quote-pricing-btn"
              v-on:click="openPricingDetailsModal"
              aria-label="View quote details"
            >
              <i class="question circle outline icon"></i>
            </button>
          </span>
        </div>
      </div>
      <div class="sixteen wide column sidebar-contact-col">
        <div
          class="sidebar-contact-field"
          :class="{
            'has-sm8': hasSm8Job,
            'is-placeholder': !contactDisplayName
          }"
          v-on:click="openRelinkModal"
          role="button"
          tabindex="0"
          :aria-label="contactDisplayName ? ('Customer ' + contactDisplayName) : 'Select customer'"
          v-on:keydown.enter.prevent="openRelinkModal"
          v-on:keydown.space.prevent="openRelinkModal"
        >
          <span class="sidebar-contact-field__name">{{ contactDisplayName || 'Select customer...' }}</span>
          <span v-if="hasSm8Job" class="sidebar-contact-field__sm8">
            <img
              :src="serviceM8IconSrc"
              alt=""
              class="sidebar-contact-field__sm8-icon"
              width="14"
              height="14"
              aria-hidden="true"
            >
            <span class="sidebar-contact-field__sm8-text">{{ sm8JobLabel }}</span>
          </span>
        </div>
      </div>

      <div class="sidebar-box">
        <div v-if="!sidebarItems.length">No tasks or products currently in quote.</div>
        <div
          class="sidebar-item"
          v-for="(item, index) in sidebarItems"
          :key="item.id != null ? 'line-' + item.id : (item.uuid + '-' + (item.item_id || index))"
          draggable="true"
          v-bind:class="{
            'sidebar-item--dragging': draggedIndex === index,
            'sidebar-item--drag-over': dragOverIndex === index
          }"
          v-on:dragstart="onSidebarDragStart($event, index)"
          v-on:dragend="onSidebarDragEnd"
          v-on:dragover.prevent="onSidebarDragOver($event, index)"
          v-on:dragleave="onSidebarDragLeave($event, index)"
          v-on:drop="onSidebarDrop($event, index)"
        >
          <div class="ui grid">
            <div class="eight wide column item">
              <div class="task-code">{{ item.code }}</div>
              <div class="task-title">{{ item.title }}</div>
            </div>
            <div class="left floated right aligned three wide column quantity" v-if="showSidebarQtySelect(item)" draggable="false">
              <app-select
                :defaultLabel="''"
                :items="[{id: 1, name: 1}, {id: 2, name: 2}, {id: 3, name: 3}, {id: 4, name: 4}, {id: 5, name: 5}, {id: 6, name: 6}, {id: 7, name: 7}, {id: 8, name: 8}, {id: 9, name: 9}, {id: 10, name: 10}, {id: 11, name: 11}, {id: 12, name: 12}, {id: 13, name: 13}, {id: 14, name: 14}, {id: 15, name: 15}, {id: 16, name: 16}, {id: 17, name: 17}, {id: 18, name: 18}, {id: 19, name: 19}, {id: 20, name: 20}, {id: 21, name: 21}, {id: 22, name: 22}, {id: 23, name: 23}, {id: 24, name: 24}, {id: 25, name: 25}, {id: 26, name: 26}, {id: 27, name: 27}, {id: 28, name: 28}, {id: 29, name: 29}, {id: 30, name: 30}, {id: 31, name: 31}, {id: 32, name: 32}, {id: 33, name: 33}, {id: 34, name: 34}, {id: 35, name: 35}, {id: 36, name: 36}, {id: 37, name: 37}, {id: 38, name: 38}, {id: 39, name: 39}, {id: 40, name: 40}, {id: 41, name: 41}, {id: 42, name: 42}, {id: 43, name: 43}, {id: 44, name: 44}, {id: 45, name: 45}, {id: 46, name: 46}, {id: 47, name: 47}, {id: 48, name: 48}, {id: 49, name: 49}, {id: 50, name: 50}, {id: 51, name: 51}, {id: 52, name: 52}, {id: 53, name: 53}, {id: 54, name: 54}, {id: 55, name: 55}, {id: 56, name: 56}, {id: 57, name: 57}, {id: 58, name: 58}, {id: 59, name: 59}, {id: 60, name: 60}, {id: 61, name: 61}, {id: 62, name: 62}, {id: 63, name: 63}, {id: 64, name: 64}, {id: 65, name: 65}, {id: 66, name: 66}, {id: 67, name: 67}, {id: 68, name: 68}, {id: 69, name: 69}, {id: 70, name: 70}, {id: 71, name: 71},{id: 72, name: 72}, {id: 73, name: 73}, {id: 74, name: 74}, {id: 75, name: 75}, {id: 76, name: 76}, {id: 77, name: 77}, {id: 78, name: 78}, {id: 79, name: 79}, {id: 80, name: 80}, {id: 81, name: 81}, {id: 82, name: 82}, {id: 83, name: 83}, {id: 84, name: 84}, {id: 85, name: 85}, {id: 86, name: 86}, {id: 87, name: 87}, {id: 88, name: 88}, {id: 89, name: 89}, {id: 90, name: 90}, {id: 91, name: 91}, {id: 92, name: 92}, {id: 93, name: 93}, {id: 94, name: 94}, {id: 95, name: 95}, {id: 96, name: 96}, {id: 97, name: 97}, {id: 98, name: 98}, {id: 99, name: 99}]"
                :value="item.qty"
                :centered="true"
                @selected="updateQty(item, $event)">
              </app-select>
            </div>
            <div class="left floated right aligned four wide column time-cost">
              <div class="task-time" v-if="item.item_type === 'task'">{{ labourTimeHoursMinutes(item) }}</div>
              <div class="task-cost" v-if="parseFloat(item.callout_fee) > 0">
                {{ currency(taskUnitPrice(item), '$', 2, { decimalSeperator: ','}) }}
              </div>
              <div class="task-cost" v-else>
                {{ currency(taskUnitPrice(item), '$', 2, { decimalSeperator: ','}) }}
              </div>
            </div>
            <div class="one wide column options" draggable="false">
              <div class="ui dropdown icon item">
                <i class="ellipsis horizontal icon"></i>
                <div class="menu">
                  <div class="item" v-if="item.item_type === 'task'" @click="editTask(item)">
                    Edit
                  </div>
                  <div class="item" v-if="item.item_type === 'product'">
                    Edit
                  </div>
                  <div class="item" @click="deleteItem(item)">
                    Remove
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="quote-totals-box" v-bind:class="{ 'quote-totals-box--expanded': pricingDetailsOpen }">

        <div class="ui grid quote-totals">

          <div class="sixteen wide column quote-pricing-toggle-row desktop-only-quote-pricing">
            <div class="quote-pricing-toggle-wrap">
              <button
                type="button"
                class="quote-pricing-toggle link-medium"
                v-on:click="togglePricingDetails"
                v-bind:aria-expanded="pricingDetailsOpen"
              >
                <i class="chevron icon" v-bind:class="pricingDetailsOpen ? 'down' : 'up'"></i>
                <span class="quote-pricing-toggle-label">{{ pricingDetailsOpen ? 'Hide details' : 'Show details' }}</span>
              </button>
            </div>
          </div>

          <template v-if="pricingDetailsOpen">
            <div class="right aligned nine wide column quote-pricing-labels-col desktop-only-quote-pricing">
              <div class="quote-pricing-detail-label">Labour time</div>
              <div class="quote-pricing-detail-label">Product Cost</div>
              <div class="quote-pricing-detail-label quote-pricing-detail-label--section-end">Gross Profit</div>
              <div class="quote-pricing-detail-label" v-if="$store.getters['setting/getAccount'].price_structure === 1 && quote.callout_fee > 0">Callout Fee</div>
              <div class="quote-pricing-detail-label">Discount</div>
              <div class="quote-pricing-detail-label">Subtotal</div>
              <div class="quote-pricing-detail-label">Total GST</div>
            </div>

            <div class="right aligned six wide column quote-pricing-values-col desktop-only-quote-pricing">
              <div class="quote-pricing-detail-value">{{ quote.labour_time_hours }}hr {{ quote.labour_time_minutes }}min</div>
              <div class="quote-pricing-detail-value">{{ currency(quoteMarginSummary.cost_total, '$', 2, { decimalSeperator: ','}) }}</div>
              <div class="quote-pricing-detail-value quote-pricing-detail-value--section-end">{{ currency(quoteMarginSummary.gross_profit, '$', 2, { decimalSeperator: ','}) }}</div>
              <div class="quote-pricing-detail-value" v-if="$store.getters['setting/getAccount'].price_structure === 1 && quote.callout_fee > 0">{{ currency(quote.callout_fee, '$', 2, { decimalSeperator: ','}) }}</div>
              <div class="quote-pricing-detail-value">{{ currency(quote.discount, '$', 2, { decimalSeperator: ','}) }}</div>
              <div class="quote-pricing-detail-value">{{ currency(quote.sub_total, '$', 2, { decimalSeperator: ','}) }}</div>
              <div class="quote-pricing-detail-value">{{ currency(quote.gst_total, '$', 2, { decimalSeperator: ','}) }}</div>
            </div>
          </template>

          <div class="right aligned nine wide column quote-total-heading desktop-only-quote-total">
            TOTAL:
          </div>

          <div class="right aligned six wide column quote-total desktop-only-quote-total">
            {{ currency(quote.total, '$', 2, { decimalSeperator: ','}) }}
          </div>

          <div class="sixteen wide column">

            <div class="ui fluid buttons">
              <button class="ui bottom primary button" tabindex="0" v-on:click="previewButton"
                      v-bind:class="{'disabled':quoteItems.length < 1}">PREVIEW
              </button>

              <button class="ui bottom right icon primary button button-save" tabindex="0" v-bind:class="{loading:saving, disabled:saving}" v-on:click="save">
                <img src="../../../assets/img/icn_box.svg" alt="" class="button-save-icon" aria-hidden="true">
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

    <app-preview-modal v-if="previewModalVisible"
        :parent_quote="quote"
        :parent_quote_items="quoteItems"
        :parent_contacts="contacts"
        :parent_contact="safeContact"
        :searchContacts="searchContacts"
        :parent_save="save"
        @send="sendQuoteButton"
        @duplicate="initDuplicate"
        @option-change="onPreviewOptionChange"
        @close="previewModalVisible=false"
        @quote="quote=$event"
        @items="quoteItems=$event"
        @discount="applyDiscount">
    </app-preview-modal>

    <duplicate-option-modal
      v-if="duplicateChooserVisible"
      :visible="duplicateChooserVisible"
      :option-count="(quote.options && quote.options.length) || 1"
      @close="closeDuplicateChooser"
      @cancel="closeDuplicateChooser"
      @variation="onDuplicateVariation"
      @new-quote="onDuplicateNewQuote">
    </duplicate-option-modal>

    <option-modal v-if="optionModalVisible" :content="quote" @close="optionModalVisible = false" @cancel="optionModalVisible = false; previewModalVisible = true" @email="sendModalVisible=true" @download="downloadPdf"></option-modal>

    <app-send-modal v-if="sendModalVisible"
        :parent_quote="quote"
        :parent_quote_items="quoteItems"
        :parent_contact="safeContact"
        :parent_save="save"
        @back="sendBackButton"
        @close="sendModalVisible=false; optionModalVisible=false"
        @quote="quote=$event">
    </app-send-modal>

    <app-customer v-if="customerModalVisible"
        ref="duplicateCustomer"
        :parent_quote="quote"
        duplicate
        @duplicate="duplicate"
        @back="customerModalVisible = false">
    </app-customer>

    <app-customer v-if="relinkModalVisible"
        :parent_quote="quote"
        submit-label="Update Customer"
        @start="onRelink"
        @back="relinkModalVisible = false">
    </app-customer>

    <app-pricing-pin-verification-modal
      :open="pricingPinModalVisible"
      @close="closePricingPinModal"
      @cancel="closePricingPinModal"
      @verified="onPricingPinVerified">
    </app-pricing-pin-verification-modal>

    <app-quote-totals-modal
      :open="pricingDetailsModalVisible"
      :quote="quote"
      :quote-items="quoteItems"
      @close="closePricingDetailsModal"
    />
</div>
</template>
